import React, { Component } from "react";
import { View } from "react-native";
import PrimaryNav from "./src/navigations/PrimaryNav";
import { appStyles } from "./src/theme/styles";
import { Provider } from "mobx-react";
import { NavigationContainer } from "@react-navigation/native";
// import firebase from 'react-native-firebase';
// import {refreshToken, saveTokenRequest} from './src/utils/api';
// import {getUser, refreshUser} from './src/database/UserDal';
// navigator.geolocation = require('@react-native-community/geolocation');

import * as Font from "expo-font";
import AppStore from './src/utils/AppStore'

export default class App extends Component {
  constructor() {
    super();
    Font.loadAsync({
      IRANSansMobile: require("./assets/fonts/IRANSansMobile.ttf"),
    })
      .then((res) => {})
      .catch((err) => {});
  }
  render() {
    return (
      <Provider store={AppStore}>
        <View style={appStyles.container}>
          <View style={appStyles.screenWraper}>
            <NavigationContainer>
              <PrimaryNav />
            </NavigationContainer>
          </View>
        </View>
      </Provider>
    );
  }

  // componentDidMount() {
  //     if (getUser() != null) {
  //         refreshToken((isConnect, response) => {
  //             if (isConnect && response.isSuccess) {
  //                 console.log(response)
  //                 refreshUser(getUser()?.cellphone, response.data.token)
  //
  //             }
  //         })
  //     }
  //
  //     this.checkPermission();
  //     firebase.messaging().onMessage((message) => {
  //         console.log('message ' + JSON.stringify(message))
  //         if (Platform.OS === 'android') {
  //             const channel = new firebase.notifications.Android.Channel(
  //                 'channelId',
  //                 'Channel Name',
  //                 firebase.notifications.Android.Importance.Max
  //             ).setDescription('A natural description of the channel');
  //
  //             firebase.notifications().android.createChannel(channel);
  //             const localNotification = new firebase.notifications.Notification({
  //                 sound: 'default',
  //                 show_in_foreground: true,
  //             })
  //                 .setNotificationId(message._from)
  //                 .setTitle(message._data.title)
  //                 .setSubtitle('')
  //                 .setBody(message._data.body)
  //                 .setData(message._data)
  //                 .android.setSmallIcon('asan_noti_logo')
  //                 .android.setChannelId('channelId') // e.g. the id you chose above
  //                 .android.setColor('#000000') // you can set a color here
  //                 .android.setAutoCancel(true)
  //                 .android.setPriority(firebase.notifications.Android.Priority.High);
  //
  //             firebase.notifications()
  //                 .displayNotification(localNotification)
  //                 .catch(err => console.error(err));
  //
  //         } else if (Platform.OS === 'ios') {
  //
  //             const localNotification = new firebase.notifications.Notification()
  //                 .setNotificationId(message._from)
  //                 .setTitle(message._data.title)
  //                 .setSubtitle('')
  //                 .setBody(message._data.body)
  //                 .setData(message._data);
  //
  //             firebase.notifications()
  //                 .displayNotification(localNotification)
  //                 .catch(err => console.error(err));
  //
  //         }
  //     })
  //
  //
  // }
  //
  // checkPermission() {
  //     firebase.messaging().hasPermission().then(enabled => {
  //         console.log(enabled)
  //         if (enabled) {
  //             this.getToken();
  //         } else {
  //             this.requestPermission();
  //         }
  //     });
  //
  // }
  //
  // getToken() {
  //
  //     firebase.messaging().getToken().then(token => {
  //         if (token) {
  //             // user has a device token
  //             this.sendPush(token.toString())
  //         }
  //     });
  //     try {
  //         firebase.messaging().subscribeToTopic('servant');
  //     } catch (e) {
  //         console.log('')
  //     }
  // }
  //
  // sendPush(token) {
  //     // saveTokenRequest(token, (isconnect, response) => {
  //
  //     // })
  // }
  //
  // requestPermission() {
  //     try {
  //         firebase.messaging().requestPermission().then(okey => {
  //             this.getToken();
  //         });
  //         // User has authorised
  //
  //     } catch (error) {
  //         // User has rejected permissions
  //         console.log('permission rejected');
  //     }
  // }
}

console.disableYellowBox = true;
